export default __webpack_public_path__ + "static/retreat_4-7449c1b60bbc8ed08507b3aa7331ff20.jpg";